import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loader", "LoadingComponent"];
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import LoadingScreen from 'pricing-pages-ui-components/components/LoadingScreen';
function makeLoadable(_ref) {
  let {
      loader,
      LoadingComponent
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Loadable(Object.assign({
    loader,
    LoadingComponent
  }, rest));
}
export const PublicMarketingHubPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "public-marketing-hub-page" */'./marketing/PublicMarketingHubPage'),
  LoadingComponent: LoadingScreen
});
export const PublicContentHubPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "public-content-hub-page" */'./content/PublicContentHubPage'),
  LoadingComponent: LoadingScreen
});